import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TechNavbar } from "@/components/tech/TechNavbar";
import { TechHero } from "@/components/tech/TechHero";
import { TechTrust } from "@/components/tech/TechTrust";
import { TechTotal } from "@/components/tech/TechTotal";
import { TechProjects } from "@/components/tech/TechProjects";
import { TechAmbits } from "@/components/tech/TechAmbits";
import { TechProcess } from "@/components/tech/TechProcess";
import { TechContact } from "@/components/tech/TechContact";
import { TechFooter } from "@/components/tech/TechFooter";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Privacy from "@/pages/Privacy";

const Home = () => (
  <div className="font-sans text-slate-900 bg-slate-50 antialiased">
    <TechNavbar />
    <main>
      <TechHero />
      <TechTrust />
      <TechTotal />
      <TechProjects />
      <TechAmbits />
      <TechProcess />
      <TechContact />
    </main>
    <TechFooter />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
